// develop 의 펀드 · 지수 · 부동산 화면이 쓰는 구 API 계층.
//
// uschool 의 `@api/asset` 은 같은 이름의 `getAnalysis` 를 갖고 있지만
// `bts/assets/{assetId}/analysis` (신규 경로) 를 부르고 시그니처도 다르다.
// 옮겨온 화면의 동작을 바꾸지 않기 위해 구 버전을 별도 모듈로 둔다.
// 경로는 P3 에서 `/bts` 하위로 옮겼다. 시그니처는 구버전 그대로 둔다 —
// 신규 `@api/asset` 의 getAnalysis 와는 여전히 다른 엔드포인트다.
import { ArtificailIndexDataType } from "types/common";
import axios from "@utils/axios";

export const getAnalysis = async (
  ticker,
  assetType,
  market,
  begin: null | string = "20000101",
  end: null | string = null,
  moving_avg: boolean = false,
) => {
  // P3: 경로가 `/bts` 하위로 옮겨졌다. assetType/market 조합은 그대로다
  // ("fund"/"kr", "index"/"global", "realty"/"realty_indexes").
  const url = `bts/${assetType}/${market}/analysis/${ticker}`;
  const response = await axios.get(url, { params: { begin, end, moving_avg } });
  return response.data.data;
};

export const reducePriceValue = (responseObj): ArtificailIndexDataType => {
  try {
    return {
      records: responseObj.records,
      monthlyRecords: responseObj.monthly_records,
      chartBaseDates: responseObj.base_dates,
      chartData: responseObj.chart_data,
      startDate: Date.parse(responseObj.start_date),
      extraNavMemo: responseObj.extra_nav_memo,
      undlInfo: responseObj.undl_info,
      is_missing: responseObj.is_missing,
    };
  } catch (e) {
    return {
      records: "",
      monthlyRecords: "",
      chartBaseDates: [],
      chartData: [],
      startDate: "",
      extraNavMemo: "",
      undlInfo: "",
      is_missing: true,
    };
  }
};
